import { borderRadius } from "../borders";

export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.primary,
    },
  },
};
